// --------------------------------------------------------------
// Created On: 2023-09-29
// Author: Zachary Thomas
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2024 - 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import formatDateLocal from "../../../utilities/time/formatDateLocal";
import styles from "./DeviceStatusRow.module.scss";

// A single row in a table that represents a monitoring device's status information.
export default function DeviceStatusRow(props: Props): Component {
  return (
    <tr data-test="device-status-row" className={`${styles.body} selectable-container`} onClick={() => props.onClick()}>
      <td data-test="device-status-device-identifier">{props.deviceIdentifier}</td>
      <td data-test="device-status-device-type">{props.deviceType}</td>
      <td data-test="device-status-activation-status">
        {props.activationStatus === null ? "N/A" : props.activationStatus}
      </td>
      <td data-test="device-status-connected">{props.connected === null ? "N/A" : props.connected}</td>
      <td data-test="device-status-modbus-error">{props.modbusError === null ? "N/A" : props.modbusError}</td>
      <td data-test="device-status-signal-strength">{props.signalStrength === null ? "N/A" : props.signalStrength}</td>
      <td data-test="device-status-last-comm">{props.lastComm === null ? "N/A" : formatDateLocal(props.lastComm)}</td>
      <td data-test="device-status-firmware-version">
        {props.firmwareVersion === null ? "N/A" : props.firmwareVersion}
      </td>
    </tr>
  );
}

interface Props {
  deviceIdentifier: string;
  deviceType: string;
  activationStatus: string | null;
  connected: string | null;
  modbusError: string | null;
  signalStrength: string | null;
  lastComm: string | null;
  firmwareVersion: string | null;
  onClick: () => void;
}
